import React from 'react'
import { Flipper, Flipped, spring } from 'react-flip-toolkit'

import Donation from './Donation'

// react-flip-toolkit-animated list of donor rows. flipKey is the
// concatenated order ids — when polling brings in new ids at the
// top, FLIP measures the existing rows' positions before and after
// React commits the new layout, then animates them from old → new
// position. Without RFT the rows would just snap down. onAppear /
// onExit fade rows in/out via the spring helper. Adapted from
// donate_v6/goal/Donations.jsx; only the BS5 .list-group-flush
// vocabulary changed to Tailwind dividers.
const Donations = ({ i18n, orders }) =>
  orders.length
    ? <Flipper
        flipKey={orders.map(o => o.id).join()}
        element="ul"
        className="divide-y divide-gray-200"
      >
        {orders.map(order =>
          <Flipped
            key={order.id}
            flipId={order.id.toString()}
            onAppear={el =>
              spring({
                config: { overshootClamping: true },
                values: { opacity: [ 0, 1 ] },
                onUpdate: ({ opacity }) => el.style.opacity = opacity,
              })
            }
            onExit={(el, _index, removeElement) =>
              spring({
                config: { overshootClamping: true },
                values: { opacity: [ 1, 0 ] },
                onUpdate: ({ opacity }) => el.style.opacity = opacity,
                onComplete: removeElement,
              })
            }
          >
            <li className="py-3">
              <Donation i18n={i18n} order={order} />
            </li>
          </Flipped>
        )}
      </Flipper>
    : <p className="py-4 text-center text-gray-500">
        {i18n.t('goal.no_donations')}
      </p>

export default Donations
